"use client";

import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useButton } from "./X5NMLKT6.js";
import { useDisclosureProviderContext } from "./S6EF7IVO.js";
import { createElement, createHook, forwardRef } from "./LMDWO4NN.js";
import { useBooleanEvent, useEvent, useMergeRefs, useMetadataProps } from "./ABQUS43J.js";
import { __objRest, __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/disclosure/disclosure.tsx
import { invariant } from "@ariakit/core/utils/misc";
import { useEffect, useRef, useState } from "react";
var TagName = "button";
var symbol = Symbol("disclosure");
var useDisclosure = createHook(function useDisclosure2(_a) {
  var _b = _a,
    store = _b.store,
    _b$toggleOnClick = _b.toggleOnClick,
    toggleOnClick = _b$toggleOnClick === void 0 ? true : _b$toggleOnClick,
    props = __objRest(_b, ["store", "toggleOnClick"]);
  var context = useDisclosureProviderContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "Disclosure must receive a `store` prop or be wrapped in a DisclosureProvider component.");
  var ref = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var disclosureElement = store.useState("disclosureElement");
  var open = store.useState("open");
  useEffect(function () {
    var isCurrentDisclosure = disclosureElement === ref.current;
    if (!(disclosureElement == null ? void 0 : disclosureElement.isConnected)) {
      store == null ? void 0 : store.setDisclosureElement(ref.current);
      isCurrentDisclosure = true;
    }
    setExpanded(open && isCurrentDisclosure);
  }, [disclosureElement, store, open]);
  var onClickProp = props.onClick;
  var toggleOnClickProp = useBooleanEvent(toggleOnClick);
  var _useMetadataProps = useMetadataProps(props, symbol, true),
    _useMetadataProps2 = _slicedToArray(_useMetadataProps, 2),
    isDuplicate = _useMetadataProps2[0],
    metadataProps = _useMetadataProps2[1];
  var onClick = useEvent(function (event) {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    if (isDuplicate) return;
    if (!toggleOnClickProp(event)) return;
    store == null ? void 0 : store.setDisclosureElement(event.currentTarget);
    store == null ? void 0 : store.toggle();
  });
  var contentElement = store.useState("contentElement");
  props = __spreadProps(__spreadValues(__spreadValues({
    "aria-expanded": expanded,
    "aria-controls": contentElement == null ? void 0 : contentElement.id
  }, metadataProps), props), {
    ref: useMergeRefs(ref, props.ref),
    onClick: onClick
  });
  props = useButton(props);
  return props;
});
var Disclosure = forwardRef(function Disclosure2(props) {
  var htmlProps = useDisclosure(props);
  return createElement(TagName, htmlProps);
});
export { useDisclosure, Disclosure };